/* Carry section: scroll-driven horizontal slide, smoothed. Re-binds if React re-renders the section. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 760px)');
  var el = null, shift = 0, target = 0, current = 0, running = false;

  function bind() {
    var sec = document.querySelector('[data-carry-motion]');
    if (!sec) { el = null; return false; }
    if (el && el.sec === sec) return true;
    var q = function (s) { return sec.querySelector(s); };
    el = {
      sec: sec, track: q('[data-cm-track]'), hint: q('[data-cm-hint]'),
      reveal: q('[data-cm-reveal]'), copy: q('.carry-copy'),
      prod: q('[data-cm-product]'), rest: q('[data-cm-restaurant]'),
      mProd: q('[data-cm-m-product]'), mRest: q('[data-cm-m-restaurant]')
    };
    // Images sit off-screen inside a clipped track: load them up front so they never pop in.
    sec.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    layout(true);
    return true;
  }

  function clamp(v) { return Math.min(1, Math.max(0, v)); }
  function ease(t) { return .5 - Math.cos(Math.PI * t) / 2; }   // gentle sine in-out

  function readTarget() {
    var r = el.sec.getBoundingClientRect(), total = r.height - window.innerHeight;
    var raw = total > 0 ? clamp(-r.top / total) : 0;
    return clamp((raw - .1) / .8);                              // short dwell at start and end
  }

  function layout(snap) {
    if (!el) return;
    if (reduce.matches) { el.sec.style.height = ''; return; }
    var vh = window.innerHeight;
    // Mobile: size from a height that ignores the browser toolbar, so the section (and the buy box
    // right below it) does not grow/shrink when Safari's address bar shows or hides while scrolling.
    if (mobile.matches) { shift = 0; el.sec.style.height = Math.round(stableVH() * 2.2) + 'px'; }
    else {
      var gap = parseFloat(getComputedStyle(el.sec).getPropertyValue('--cm-gap')) || 64;
      shift = el.prod.getBoundingClientRect().width + gap;
      el.sec.style.height = Math.round(vh + Math.max(shift * 1.8, vh)) + 'px';
    }
    target = readTarget();
    if (snap) current = target;
    render(current);
  }

  function render(t) {
    var p = ease(t);
    var rv = clamp((p - .62) / .3);
    el.hint.style.opacity = String(clamp(1 - t * 5));
    el.reveal.style.opacity = String(rv);
    el.reveal.style.transform = 'translate3d(0,' + (12 * (1 - rv)).toFixed(2) + 'px,0)';
    if (mobile.matches) {
      el.track.style.transform = ''; el.copy.style.transform = '';
      el.mProd.style.transform = 'translate3d(' + (-p * 100).toFixed(3) + '%,0,0)';
      el.mRest.style.transform = 'translate3d(' + ((1 - p) * 100).toFixed(3) + '%,0,0)';
      el.mRest.firstElementChild.style.transform = 'scale(' + (1.06 - .06 * p).toFixed(4) + ')';
    } else {
      el.track.style.transform = 'translate3d(' + (-shift * p).toFixed(2) + 'px,0,0)';
      el.copy.style.transform = 'translate3d(' + (shift * .05 * Math.sin(Math.PI * p)).toFixed(2) + 'px,0,0)';
      el.prod.style.opacity = String((1 - .5 * p).toFixed(3));
      el.prod.firstElementChild.style.transform = 'scale(' + (1 - .05 * p).toFixed(4) + ')';
      el.rest.firstElementChild.style.transform = 'scale(' + (1.08 - .08 * p).toFixed(4) + ')';
    }
  }

  // Ease the rendered position toward the scroll position every frame (no wheel-step jumps).
  function tick() {
    if (!el || !el.sec.isConnected) { running = false; if (bind()) start(); return; }
    var d = target - current;
    current = Math.abs(d) < .0005 ? target : current + d * .14;
    render(current);
    if (current !== target) requestAnimationFrame(tick); else running = false;
  }
  function start() { if (!running) { running = true; requestAnimationFrame(tick); } }

  function onScroll() {
    if (!el && !bind()) return;
    if (reduce.matches) return;
    target = readTarget();
    start();
  }
  var lastW = window.innerWidth, stableH = 0;
  function stableVH() {                                    // locked per width; refreshed on rotation/resize of width
    if (!stableH) stableH = window.innerHeight;
    return stableH;
  }
  function onChange() { if (bind()) layout(true); }
  function onResize() {
    // Height-only resizes on phones = toolbar show/hide: keep the layout, just update the animation.
    if (mobile.matches && window.innerWidth === lastW && el) { onScroll(); return; }
    lastW = window.innerWidth; stableH = 0; onChange();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  window.addEventListener('load', onChange);
  if (mobile.addEventListener) { mobile.addEventListener('change', onChange); reduce.addEventListener('change', onChange); }
  // In-page links (e.g. « Choose your set » -> #offers) would otherwise scroll smoothly *through* the
  // pinned sections and seem to stop on them: go straight to the target instead.
  function pageTop(el) { var y = 0; while (el) { y += el.offsetTop; el = el.offsetParent; } return y; }  // ignores reveal transforms
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var id = a.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target || id === 'main' || id === 'top') return;
    if (Math.abs(target.getBoundingClientRect().top) < window.innerHeight * 1.2) return;   // short hops: native smooth scroll
    e.preventDefault();
    var header = document.querySelector('.site-header');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    window.scrollTo({ top: Math.max(0, pageTop(target) - offset), behavior: 'instant' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  }, true);

  // React hydrates after this script; catch a re-rendered section.
  new MutationObserver(function () { if (!el || !el.sec.isConnected) onChange(); })
    .observe(document.documentElement, { childList: true, subtree: true });
  onChange();
})();
